<template>
  <v-container grid-list-md>
    <v-layout
        row
        wrap
        mb-4
    >
      <v-flex
        xs12>
        <h3>Gender</h3>
      </v-flex>
      <fb-audience-card-item
        v-for="(card, index) in items.gender"
        :key="index"
        :selected="selected.gender"
        :item="card"
        array="gender"
        @selectItem="selectItem"
      />
    </v-layout>

    <v-layout
      row
      wrap
      mb-4
    >
      <v-flex
        xs12>
        <h3>Age</h3>
      </v-flex>
      <fb-audience-card-item
        v-for="(card, index) in items.age"
        :key="index"
        :selected="selected.age"
        :item="card"
        array="age"
        @selectItem="selectItem"
      />
    </v-layout>

    <!--<v-layout-->
      <!--row-->
      <!--wrap-->
      <!--mb-4-->
    <!--&gt;-->
      <!--<v-flex-->
        <!--xs12>-->
        <!--<h3>Ethnicity</h3>-->
      <!--</v-flex>-->
      <!--<fb-audience-card-item-->
        <!--v-for="(card, index) in items.ethnicity"-->
        <!--:key="index"-->
        <!--:selected="selected.ethnicity"-->
        <!--:item="card"-->
        <!--array="ethnicity"-->
        <!--@selectItem="selectItem"-->
      <!--/>-->
    <!--</v-layout>-->

    <v-layout
      row
      wrap
      mb-4
    >
      <v-flex
        xs12>
        <h3>Politics</h3>
      </v-flex>
      <fb-audience-card-item
        v-for="(card, index) in items.politics"
        :key="index"
        :selected="selected.politics"
        :item="card"
        array="politics"
        @selectItem="selectItem"
      />
    </v-layout>
    <v-layout
      row
      wrap
      mb-4
    >
      <v-flex
        xs12>
        <h3>Interests</h3>
      </v-flex>
      <fb-audience-card-item
        v-for="(card, index) in items.interests"
        :key="index"
        :selected="selected.interests"
        :item="card"
        array="interests"
        @selectItem="selectItem"
      />
    </v-layout>

    <v-layout
      row
      wrap
      mb-4
    >
      <v-flex
        xs12>
        <h3>Work/Life</h3>
      </v-flex>
      <fb-audience-card-item
        v-for="(card, index) in items.occupation"
        :key="index"
        :selected="selected.occupation"
        :item="card"
        array="occupation"
        @selectItem="selectItem"
      />
    </v-layout>
  </v-container>
</template>

<script>
import audiences from '../../../../../static/audiences'
import FbAudienceCardItem from './FbAudienceCardItem'
export default {
  name: 'fb-audience',
  components: {
    FbAudienceCardItem
  },
  data () {
    return {
      items: {},
      selected: {
        gender: {
          name: ['All'],
          genders: []
        },
        age: {
          name: ['All'],
          age_min: 18,
          age_max: 65
        },
        politics: {
          name: ['All'],
          politics: []
        },
        interests: {
          name: ['All'],
          interests: []
        },
        occupation: {
          name: ['All'],
          family_statuses: [],
          industries: []
        }
      }
    }
  },
  created () {
    this.items = audiences
  },
  mounted () {
    this.getTargeting()
  },
  methods: {
    selectItem (item, array) {
      // Note: can not select multiple cards in age category
      if (array === 'age') {
        this.selected['age'].name = [item.name]
        this.selected['age'].age_min = item.age_min
        this.selected['age'].age_max = item.age_max
      } else {
        // Note: if click All clear the state
        const keys = Object.keys(item)
        if (item.name === 'All') {
          this.selected[array].name = ['All']
          keys.forEach(key => {
            if (key !== 'name') this.selected[array][key] = []
          })
        } else {
          // Note: otherwise check if already exist selected category
          // Note: if exist, add item to existing category
          const index = this.selected[array].name.findIndex(n => n === item.name)
          if (index === -1) {
            this.selected[array].name = this.selected[array].name.filter(n => n !== 'All')
            this.selected[array].name.push(item.name)
            keys.forEach(key => {
              if (key !== 'name') {
                this.selected[array][key] = this.selected[array][key].concat(item[key])
              }
            })
          } else {
            // Note: if not exist, clear items
            this.selected[array].name = this.selected[array].name.filter(n => n !== item.name)
            // Note: if no items selected left, set as All
            if (!this.selected[array].name.length) {
              this.selected[array].name = ['All']
              keys.forEach(key => {
                if (key !== 'name') {
                  this.selected[array][key] = []
                }
              })
            } else {
              keys.forEach(key => {
                if (key !== 'name') {
                  this.selected[array][key] = this.selected[array][key].filter(i => !item[key].includes(i))
                }
              })
            }
          }
        }
      }
      this.getTargeting()
    },
    getTargeting () {
      const targeting = {}
      const selectedAudience = []
      const fields = Object.keys(this.selected)
      fields.forEach(field => {
        selectedAudience.push({
          name: field,
          value: this.selected[field].name
        })
        // Note: remove all items with name All
        if (this.selected[field].name.find(n => n === 'All')) return false
        const targets = Object.keys(this.selected[field])
        targets.forEach(target => {
          if (target !== 'name') {
            if (typeof this.selected[field][target] === 'object') {
              targeting[target] = [...this.selected[field][target]]
            } else targeting[target] = this.selected[field][target]
          }
        })
      })
      this.$emit('setCampaignProperty', 'selectedAudiences', selectedAudience)
      targeting['geo_locations'] = {'countries': ['US']}
      this.$emit('setTargeting', targeting, true)
    }
  }
}
</script>
